import styled, { css } from "styled-components";
import { borderRadius, fontWeights, spacing, typographyMixin } from "@magicbi/ui-library";

export const Stack = styled.div`
  display: grid;
  min-width: 0;
`;

export const Line = styled.span<{ $lead: boolean; $breakAnywhere: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing[1]};
  min-width: 0;
  ${({ $lead }) =>
    $lead
      ? css`
          ${typographyMixin("body", 4)}
          font-weight: ${fontWeights.semibold};
          color: ${({ theme }) => theme.colors.text.primary};
        `
      : css`
          ${typographyMixin("caption", 4)}
          color: ${({ theme }) => theme.colors.text.secondary};
        `}
  ${({ $breakAnywhere }) => $breakAnywhere && "overflow-wrap: anywhere;"}
  & > [data-part="icon"] {
    display: inline-flex;
    flex: none;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  & > [data-part="icon"] > svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

/** The colour arrives from data, so it is a prop; only a checked hex value reaches CSS. */
export const Swatch = styled.span<{ $color: string }>`
  flex: none;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: ${borderRadius.sm};
  background: ${({ $color }) => $color};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.border.subtle};
`;
